<template>
  <v-card class="glass-background">

    <!-- FLOATING HEADER wie bei ReservationsCard -->
    <div class="header-floating">
      <v-row dense class="justify-start">
        <v-col cols="auto">
          <Headers
            :headersTitle="'Favoriten'"
            :headersIcon="'mdi-star'"
            :headersColor="'--v-theme-background'"
          />
        </v-col>
      </v-row>
    </div>

    <!-- HAUPT-INHALT (flex container) -->
    <div class="content">

      <!-- FILTERBEREICH OBEN -->
      <div class="filters">
        <v-row dense class="justify-center align-center">
          <v-col cols="auto">
            <DropDownFavorites
              v-model="selectedPremiseName"
              :dropDownFavResLoc="favoritesCardPremises"
            />
          </v-col>
        </v-row>
      </div>

      <!-- MITTLERER FLEX-BEREICH (SCROLL + SCHATTEN) -->
      <div class="favorites-area">
        <v-card class="favoritesCard" elevation="12">
          <div class="favorites-wrapper">

            <!-- FALL: Keine Favoriten -->
            <template v-if="favoritesCardFavoritesFilteredLocation.length === 0">
              <v-card class="cardNoFavs">
                <div>Keine Favoriten ausgewählt.</div>
              </v-card>
            </template>

            <!-- FALL: Favoriten vorhanden -->
            <template v-else>
              <v-row dense class="flex-column">
                <v-col
                  cols="auto"
                  v-for="favorite in favoritesCardFavoritesFilteredLocation"
                  :key="favorite.id"
                >
                  <FavoriteCard
                    :favCardFavorit="favorite"
                    :favCardPremises="favoritesCardPremises"
                    :favCardUsers="favoritesCardUsers"
                    :favCardStartDate="favoritesCardStartDate"
                    :favCardEndDate="favoritesCardEndDate"
                    @openOccupancy="openOccupancy"
                    @updateFavorite="$emit('updateFavorite')"
                    @updateStatus="$emit('updateStatus')"
                  />
                </v-col>
              </v-row>
            </template>

          </div>
        </v-card>
      </div>

    </div>

  </v-card>
</template>

<script>
import Headers from '../consumables/Headers.vue'
import FavoriteCard from '../components/FavoriteCard.vue'
import DropDownFavorites from '../consumables/DropDownFavRes.vue'

export default {
  name: 'FavoritesCard',

  components: {
    Headers,
    DropDownFavorites,
    FavoriteCard,
  },

  props: {
    favoritesCardFavorites: { type: Array, default: () => [] },
    favoritesCardUsers: { type: Object, default: null },
    favoritesCardStartDate: { type: String, required: true },
    favoritesCardEndDate: { type: String, required: true },
    favoritesCardPremises: { type: Array, default: () => [] },
  },

  emits: ['updateStatus', 'updateFavorite', 'openOccupancy'],

  data() {
    return {
      selectedPremiseName: '',
    }
  },

  computed: {
    favoritesCardFavoritesFilteredLocation() {
      if (!this.favoritesCardFavorites.length) return []
      if (this.selectedPremiseName === 'Alle' || this.selectedPremiseName === '')
        return this.favoritesCardFavorites
      return this.favoritesCardFavorites.filter(
        fav => fav.seat.premises === this.selectedPremiseName
      )
    },
  },

  methods: {
    openOccupancy(payload) {
      this.$emit('openOccupancy', payload)
    },
  },
}
</script>

<style scoped>

.v-row, .v-col { min-width: 0; }

/* ÄUSSERE KARTE */
.glass-background {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
  position: relative;
  overflow: visible !important;
  background: rgba(var(--v-theme-surface), 0.72);
  backdrop-filter: blur(8px) saturate(120%);
  border: 1px solid rgba(var(--v-theme-surface), 0.35);
  border-radius: 32px;
  max-height: 50.25rem;
}

/* FLOATING HEADER */
.header-floating {
  position: relative;
  margin-top: -2rem;
  margin-left: 0.5rem;
  z-index: 10;
  flex-shrink: 0;
}

/* FLEX LAYOUT */
.content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* FILTER OBEN */
.filters {
  flex-shrink: 0;
  margin-top: 0.75rem;
}

/* AREA MIT SCROLL (wie ReservationsCard) */
.favorites-area {
  margin-top: 0.5rem;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* KARTE IM SCROLLBEREICH */
.favoritesCard {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
}

/* SCROLL WRAPPER MIT SCHATTEN */
.favorites-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;   /* macht den Schatten sichtbar */
  overflow-x: hidden;
}

/* KEINE FAVORITEN */
.cardNoFavs {
  border-radius: 8px;
  font-size: larger;
  font-weight: bold;
  width: 25.2rem;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
  padding: 2rem;
}
</style>
